var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "card-header",
            { attrs: { title: _vm.$router.currentRoute.meta.title } },
            [
              !_vm.serverError
                ? _c(
                    "router-link",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can:update",
                          value: _vm.permissionPrefix,
                          expression: "permissionPrefix",
                          arg: "update"
                        }
                      ],
                      staticClass: "btn btn-primary btn-sm",
                      attrs: {
                        to: {
                          name: _vm.routePrefix + ".edit",
                          params: { id: _vm.id }
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-edit" })]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _vm.serverError
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.serverError) + " ")
                    ])
                  : _vm._e()
              ])
            ]),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("files-image", {
                      attrs: { options: { id: "image", disabled: true } },
                      model: {
                        value: _vm.image,
                        callback: function($$v) {
                          _vm.image = $$v
                        },
                        expression: "image"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "en_name",
                          label: "en_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.en_name,
                        callback: function($$v) {
                          _vm.en_name = $$v
                        },
                        expression: "en_name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "ar_name",
                          label: "ar_name",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.ar_name,
                        callback: function($$v) {
                          _vm.ar_name = $$v
                        },
                        expression: "ar_name"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "jwt_callback_token",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "jwt_callback_token",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.jwt_callback_token,
                        callback: function($$v) {
                          _vm.jwt_callback_token = $$v
                        },
                        expression: "jwt_callback_token"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "web_hook_url",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "web_hook_url",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.web_hook_url,
                        callback: function($$v) {
                          _vm.web_hook_url = $$v
                        },
                        expression: "web_hook_url"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "order_prefix_url",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "order_prefix_url",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.order_prefix_url,
                        callback: function($$v) {
                          _vm.order_prefix_url = $$v
                        },
                        expression: "order_prefix_url"
                      }
                    }),
                    _c("select-countries", {
                      attrs: {
                        options: {
                          id: "country_id",
                          label: "country",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.country_id,
                        callback: function($$v) {
                          _vm.country_id = $$v
                        },
                        expression: "country_id"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "client_id",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "client_id",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.client_id,
                        callback: function($$v) {
                          _vm.client_id = $$v
                        },
                        expression: "client_id"
                      }
                    }),
                    _c("input-text", {
                      attrs: {
                        options: {
                          id: "client_secret",
                          transPrefix: _vm.transPrefix + ".fields",
                          label: "client_secret",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.client_secret,
                        callback: function($$v) {
                          _vm.client_secret = $$v
                        },
                        expression: "client_secret"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.serverError
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("input-checkbox", {
                      attrs: {
                        options: {
                          id: "enabled",
                          label: "enabled",
                          disabled: true
                        }
                      },
                      model: {
                        value: _vm.enabled,
                        callback: function($$v) {
                          _vm.enabled = $$v
                        },
                        expression: "enabled"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "card-footer" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-neutral btn-sm",
                      attrs: { to: { name: _vm.routePrefix + ".index" } }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-left" })]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }